/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IFileUploadModalControllerScope extends IBaseModalControllerScope {
        documentIds: string[],
        documentMetadataModel: models.DocumentMetadataModel;
        process: Wars.Domain.Model.Dtos.ProcessDto,
        documentConfiguration: Wars.Domain.Model.Documents.DocumentConfiguration;
        systemDocumentConfiguration: Wars.Domain.Model.Documents.SystemDocumentConfiguration;
        uniqueIdentifier: string;
        fileUploadModel: models.FileUploadModel;
        documentTypeContext: models.CodeDropDownContext;
        acceptsText: string;
        model: models.FileUploadModel;
        showDocumentTypeDropDown: boolean;
        myId: string;
        uploadFiles(files: any[]): void;
        removeDocument(index: number): void;
        canSave(): boolean;
        save(): void;
    }

    export class FileUploadModalController extends BaseModalController {
        scope: IFileUploadModalControllerScope;

        constructor(
            $scope: IFileUploadModalControllerScope,
            private $timeout: ng.ITimeoutService,
            documentIds: string[],
            process: Wars.Domain.Model.Dtos.ProcessDto,
            documentConfiguration: Wars.Domain.Model.Documents.DocumentConfiguration,
            systemDocumentConfiguration: Wars.Domain.Model.Documents.SystemDocumentConfiguration,
            uniqueIdentifier: string,
            model: models.FileUploadModel,
            private fileUploadDownloadService: services.FileUploadDownloadService,
            private processDocumentService: services.ProcessDocumentService,
            close: any)
        {
            super($scope, close);

            this.scope = $scope;
            this.scope.documentIds = documentIds;
            this.scope.process = process;
            this.scope.documentConfiguration = documentConfiguration;
            this.scope.systemDocumentConfiguration = systemDocumentConfiguration;
            this.scope.uniqueIdentifier = uniqueIdentifier;
            this.scope.model = model;

            this.scope.uploadFiles = (files: any[]) => this.uploadFiles(files);
            this.scope.removeDocument = (index: number) => this.removeDocument(index);
            this.scope.canSave = () => this.canSave();
            this.scope.save = () => this.save();
            
            this.initialize();
        }

        public save() {
            for (var i = 0; i < this.scope.model.documents.length; i++) {
                this.scope.documentMetadataModel.updateDocumentDto(this.scope.model.documents[i]);
            }
            this.dismissModal(true);
        }

        private initialize(): void {
            this.scope.myId = services.UtilityService.generateGuidComb();
            this.scope.model.documents = [];
            if (this.scope.documentIds) {
                for (var i = 0; i < this.scope.documentIds.length; i++) {
                    var document = this.processDocumentService.getDocumentById(this.scope.process, this.scope.documentIds[i]);
                    if (document) {
                        this.scope.model.documents.push(document);
                        // If multiple files all have the same metadata so don't worry about which document to use to initialize
                        this.scope.documentMetadataModel = new models.DocumentMetadataModel(document);
                    }
                }
            }

            if (!this.scope.documentMetadataModel) {
                this.scope.documentMetadataModel = new models.DocumentMetadataModel(undefined);
            }

            this.scope.acceptsText = this.scope.documentConfiguration.overrideSystemDocumentAccepts
                ? this.scope.documentConfiguration.documentAccepts
                : this.scope.systemDocumentConfiguration.documentAccepts;

            this.scope.documentTypeContext = new models.CodeDropDownContext();

            this.scope.documentTypeContext.includeSpecifiedOptionsOnly = Enumerable.from(this.scope.documentConfiguration.myAvailableDocumentTypes)
                .where(i => i.isAvailable)
                .select(i => i.mySystemCode.uniqueIdentifier)
                .toArray();

            this.scope.showDocumentTypeDropDown = this.scope.documentConfiguration.includeDocumentType &&
                Enumerable.from(this.scope.documentConfiguration.myAvailableDocumentTypes).count(i => i.isAvailable) > 1;

            // If no metadata then go ahead and open browsers file upload window
            if (!this.areInputsDisplayed()) {
                this.$timeout(() => {
                    angular.element("#" + this.scope.myId).triggerHandler('click');
                });
            }
        }

        private areInputsDisplayed(): boolean {
            var docConfig = this.scope.documentConfiguration;
            return docConfig.includeDocumentComment ||
                (docConfig.documentSecurity === Wars.Domain.Model.Codes.Enums.DocumentSecurity.CanBeMarkedSecured && this.scope.process.canSecureDocment[this.scope.uniqueIdentifier]) ||
                this.scope.showDocumentTypeDropDown;
        }

        private removeDocument(index: number) {
            this.scope.model.documents.splice(index, 1);
            this.scope.model.fileUploadProgress = undefined;
        }

        private uploadFiles(files: any[]) {
            this.scope.model.fileUploadProgress = undefined;

            this.fileUploadDownloadService.uploadFiles(files, this.scope.model).then(
                (documents) => {
                    this.scope.model.documents = documents;
                    for (var i = 0; i < this.scope.model.documents.length; i++) {
                        this.scope.documentMetadataModel.updateDocumentDto(this.scope.model.documents[i]);
                    }
                },
                response => {
                    if (response.status > 0) {
                        this.scope.model.errorMessage = response.status + ': ' + response.data;
                    }
                },
                evt => {
                    this.scope.model.fileUploadProgress = Math.min(100, parseInt((<any>(100.0 * evt.loaded / evt.total))));
                });
        }

        private canSave(): boolean {
            if (this.scope.model.documents && this.scope.model.documents.length > 0) {
                if (!this.scope.showDocumentTypeDropDown || this.scope.documentMetadataModel.documentTypeUniqueId) {
                    return true;
                }
            }
                
            return false;
        }
    }
}

warsApp.registerController("FileUploadModalController", [
    "$scope", "$timeout", "documentIds", "process", "documentConfiguration", "systemDocumentConfiguration", "uniqueIdentifier", "model", "fileUploadDownloadService", "processDocumentService", "close"
]);